module.exports = __webpack_public_path__ + "img/9788963707952.d27a0b77.jpg";